var _switch;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNdeIconFormatsDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XLS"
  }), /*#__PURE__*/React.createElement("g", {
    id: "DOC"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    stroke: "#D1D2D3",
    strokeWidth: 1.2443,
    strokeMiterlimit: 10,
    points: "41.877,18.651 79.623,18.651  79.623,82.526 28.19,82.526 28.19,33.484  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.413,
    y: 22.597,
    fill: "#1D76BB",
    width: 54.129,
    height: 21.776
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "#2A3B8F",
    points: "20.413,44.373 27.578,44.373 27.578,51.481  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34.798,28.673c1.16,1.062,1.739,2.539,1.739,4.434c0,1.893-0.566,3.391-1.696,4.494 c-1.133,1.104-2.861,1.654-5.184,1.654h-4.163V27.078h4.303C31.969,27.078,33.635,27.61,34.798,28.673z M32.803,35.911 c0.667-0.627,1-1.539,1-2.734c0-1.196-0.333-2.117-1-2.762c-0.669-0.645-1.693-0.967-3.075-0.967h-1.516v7.403h1.725 C31.179,36.852,32.134,36.538,32.803,35.911z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M48.787,37.575c-1.232,1.201-2.748,1.803-4.549,1.803c-1.8,0-3.314-0.602-4.546-1.803 c-1.23-1.203-1.848-2.697-1.848-4.486s0.617-3.283,1.848-4.487c1.231-1.2,2.746-1.802,4.546-1.802 c1.801,0,3.316,0.602,4.549,1.802c1.229,1.204,1.845,2.698,1.845,4.487S50.017,36.372,48.787,37.575z M47.863,33.098 c0-1.086-0.35-2.012-1.046-2.78c-0.696-0.765-1.554-1.148-2.569-1.148c-1.017,0-1.873,0.384-2.569,1.148 c-0.697,0.769-1.045,1.694-1.045,2.78s0.348,2.009,1.045,2.77c0.696,0.761,1.553,1.142,2.569,1.142 c1.016,0,1.873-0.381,2.569-1.142S47.863,34.184,47.863,33.098z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M57.827,36.852c1.335,0,2.427-0.528,3.275-1.585l1.741,1.794c-1.382,1.558-3.011,2.335-4.886,2.335 c-1.876,0-3.422-0.594-4.634-1.777c-1.214-1.185-1.82-2.68-1.82-4.486c0-1.805,0.616-3.312,1.854-4.52 c1.236-1.208,2.75-1.812,4.538-1.812c1.998,0,3.671,0.762,5.018,2.283l-1.688,1.916c-0.86-1.07-1.93-1.604-3.206-1.604 c-1.022,0-1.896,0.335-2.622,1.002c-0.728,0.668-1.089,1.568-1.089,2.7s0.343,2.041,1.027,2.727 C56.021,36.509,56.852,36.852,57.827,36.852z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 33.998,
    y: 50.59,
    fill: "#D1D2D3",
    width: 39.819,
    height: 4.671
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.998,
    y: 58.294,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.009
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.396,
    y: 58.294,
    fill: "#D1D2D3",
    width: 17.422,
    height: 1.009
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.998,
    y: 61.716,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.008
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.396,
    y: 61.716,
    fill: "#D1D2D3",
    width: 17.422,
    height: 1.008
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.998,
    y: 65.138,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.007
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.396,
    y: 65.138,
    fill: "#D1D2D3",
    width: 17.422,
    height: 1.007
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.998,
    y: 68.559,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.007
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.396,
    y: 68.559,
    fill: "#D1D2D3",
    width: 17.422,
    height: 1.007
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.998,
    y: 71.979,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.008
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.396,
    y: 71.979,
    fill: "#D1D2D3",
    width: 17.422,
    height: 1.008
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.998,
    y: 75.423,
    fill: "#D1D2D3",
    width: 17.42,
    height: 1.006
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.396,
    y: 75.423,
    fill: "#D1D2D3",
    width: 17.422,
    height: 1.006
  })))), /*#__PURE__*/React.createElement("g", {
    id: "PDF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "HTML"
  }), /*#__PURE__*/React.createElement("g", {
    id: "CSV"
  }), /*#__PURE__*/React.createElement("g", {
    id: "JSON"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdeIconFormatsDoc);
export default __webpack_public_path__ + "static/media/NDE_icon_formats_doc.317ac1d9.svg";
export { ForwardRef as ReactComponent };